const E = {
  'manage-access': 'manage-access',
  'current-users': 'current-users',
  'create-user': 'create-user',
  'inactive-users': 'inactive-users',
  templates: 'templates',
  jobs: 'jobs',
  submissions: 'submissions',
  supplies: 'supplies',
  invoices: 'invoices',
  food: 'food',
  'additional-analysis': 'additional-analysis',
  prepaidrequest: 'prepaid',
};

const F = {
  templates: 'des modèles',
  jobs: 'dossier',
  submissions: 'soumissions',
  supplies: 'provisions',
  invoices: 'factures',
  'manage-access': 'manage-access',
  'current-users': 'utilisateurs-actuels',
  'create-user': 'créer-un utilisateur',
  'inactive-users': 'utilisateurs-inactifs',
  food: 'aliments',
  'additional-analysis': 'additional-analysis',
  prepaidrequest: 'Prépayé',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/urls.js